import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Autocomplete from 'react-autocomplete';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { renderMenu } from '../v2/dropdowns/Menu';
function getItemValue(item) {
    return item.shipmentId;
}
class SearchBox extends Component {
    constructor(props) {
        super(props);
        this.onFocus = (e) => {
            if (this.props.onFocus) {
                this.props.onFocus(e);
            }
            this.setState({ focussed: true });
        };
        this.onBlur = (e) => {
            if (this.props.onBlur) {
                this.props.onBlur(e);
            }
            this.setState({ focussed: false });
        };
        this.onKeyPress = (e) => {
            if (e.which === 13) {
                e.preventDefault();
                this.input.setSelectionRange(-1, -1);
                this.input.click();
            }
        };
        this.renderMenu = (items, _value, style) => {
            const { dropdownStyle } = this.props;
            const menuStyle = {
                position: 'absolute',
                top: 40,
                left: 0,
            };
            return renderMenu(items, Object.assign(Object.assign(Object.assign({}, style), (this.props.menuStyle || menuStyle)), dropdownStyle));
        };
        this.state = { value: props.value || '', focussed: false };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value) {
            this.setState({ value: nextProps.value });
        }
    }
    /*
    componentWillReceiveProps(nextProps) {
      if (Object.prototype.hasOwnProperty.call(nextProps, 'value')) {
        this.setState({ value: nextProps.value });
      }
    }
    */
    onChange(event, nGramTemp) {
        const nGram = this.props.toUpperCase ? nGramTemp.toUpperCase() : nGramTemp;
        if (this.props.onChange) {
            this.props.onChange(nGram);
        }
        this.setState({ value: nGram });
        const length = this.props.nGramLength || 2;
        if (nGram.length > length) {
            this.props.search(nGram);
        }
    }
    onSelect(value, item) {
        const updatedValue = this.props.clearOnSelect ? '' : value;
        this.setState({ value: updatedValue }, this.props.onSelect(value, item, this.state.value));
    }
    renderEmptyMessage(show) {
        return (show && (React.createElement("p", { className: "mt-1 ml-1" }, this.props.emptyMessage || this.props.t('NO_RESULTS_TO_DISPLAY'))));
    }
    render() {
        const showEmptyMessage = this.props.showEmptyMessage &&
            (this.state.value || '').length > 2 &&
            (this.props.items || []).length === 0 &&
            this.state.focussed;
        return (React.createElement("div", { className: "relative", "data-testid": this.props.testDataId },
            React.createElement(Autocomplete, { wrapperStyle: {}, inputProps: {
                    placeholder: this.props.placeholder,
                    className: 'form-field',
                    style: this.props.inputStyle,
                    onFocus: this.onFocus,
                    onBlur: this.onBlur,
                    onKeyPress: this.onKeyPress,
                    id: this.props.id,
                    disabled: this.props.disabled,
                }, ref: (el) => {
                    this.input = el;
                }, items: this.props.items, value: this.props.appendItems ? this.props.value : this.state.value, getItemValue: this.props.getItemValue, onSelect: (value, item) => this.onSelect(value, item), onChange: (event, nGram) => this.onChange(event, nGram), renderMenu: this.renderMenu, renderItem: this.props.renderItem, autoHighlight: false }),
            this.renderEmptyMessage(showEmptyMessage)));
    }
}
SearchBox.propTypes = {
    value: PropTypes.string,
    getItemValue: PropTypes.func,
    items: PropTypes.array.isRequired,
    nGramLength: PropTypes.number,
    renderItem: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    placeholder: PropTypes.string.isRequired,
    search: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    clearOnSelect: PropTypes.bool,
    appendItems: PropTypes.bool,
    toUpperCase: PropTypes.bool,
    dropdownStyle: PropTypes.object,
    testDataId: PropTypes.string,
};
SearchBox.defaultProps = {
    disabled: false,
    getItemValue,
    nGramLength: 2,
    clearOnSelect: true,
    toUpperCase: false,
    dropdownStyle: {},
    testDataId: 'search-box',
};
export default withRouter(withTranslation()(SearchBox));
